<template>
    <!-- 环创VIP测试ID：b813db3794774a1b978ae690c9909531 -->
    <div class="page white_bg">

        <div style="height: 46px;">
            <header class="pageHeader detailPageHeader white_bg lightGreyBottomBorder" style="line-height: 30px;">
                <div class="borderLayout paddingH16 paddingV12">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
<!--                            <router-link class="primaryTextColor bold" to="">链接</router-link>-->
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">
            <div class="white_bg">
                <div class="alignC" style="padding-top: 32px;">
                    <img src="vip/success_icon.jpg" width="49" height="49"/>
                </div>
                <div class="marginT8 alignC font18r14 color101010">
                    恭喜你成为师讯园所精品课尊享用户
                </div>
                <div class="centered" style="width: 279px; margin-top: 52px;">
                    <button class="block yellowButton font18r14" @click="$refs.noticeForOpenPrivilegeDrawer.show()">
                        联系教务协助开通子账号
                    </button>
                    <div class="red font12r14 marginT20">
                        （请您务必在7个工作日内联系教务开通其余9个账号权益，过期不候！）
                    </div>
                </div>
            </div>
            <div class="marginT8">
                <div class="paddingV16 generalPagePaddingH">
                    <bannerModule ref="bannerModule" type="33" version="4" />
                </div>
            </div>
            <div class="alignCenter blue" style="margin-top: 48px;">
                <router-link class="blue" :to="{name:'courseVipPersonalCenter'}">回到权益中心</router-link>
            </div>
            <div style="height: 200px;"></div>

        </div>

        <noticeForOpenPrivilegeDrawer ref="noticeForOpenPrivilegeDrawer"/>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// data
import vipTypeEnum2 from '@data/vipTypeEnum2';

// module
import bannerModule from '@comp/bannerModule';
import noticeForOpenPrivilegeDrawer from "@pages/vip/noticeForOpenPrivilegeDrawer";

// util
import appHelper from '@util/appHelper';

const config = {
    apiConfig : {
    }
};

export default {
    name: "vipOpenSuccess",
    extends : shixunPagePart,
    components : { bannerModule, noticeForOpenPrivilegeDrawer },
    data () {
        return {
            title : '会员开通',
            apiConfig : config.apiConfig
        }
    },
    methods : {
        back : function () {
            appHelper.redirect('/');
        }
    }
}
</script>

<style lang="scss" scoped>
.learnButton {
    width: 279px;
    height: 36px;
    background-image: url('data:image/png;base64,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');
}
.angleIcon {
    width: 11px;
    height: 11px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAUklEQVQ4jWNgGAUDCqISc05HJ2avdnBoYKGqwdFJ2dnRiTn/aWJ4VEJO/qjhA2V4zmKaGBxDTYPhhiblUi8oRrihsCxNVUMZGCCFENUNHQVUAwBxq1ZoJvryTAAAAABJRU5ErkJggg==');
    vertical-align: middle;
}
.yellowButton {
    background: #FFBC58;
    height: 36px;
    line-height: 36px;
    border-radius: 18px;
    padding: 0 1em;
}
.red {
    color: #FE5747;
}
.blue {
    color: #5093FB;
}
</style>
